import { render, staticRenderFns } from "./PayPalButtons.vue?vue&type=template&id=be375116&"
import script from "./PayPalButtons.vue?vue&type=script&lang=js&"
export * from "./PayPalButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports